import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { NbDialogRef, NbToastrService } from '@nebular/theme';
import { ImageCroppedEvent } from 'ngx-image-cropper';
import { ImgCropperOptions } from '../../../../components/img-cropper/img-cropper.component';
import { LocalizationService } from '../../../../modules/internationalization/localization.service';
import { UtilitiesService } from '../../../../providers/utilities.provider';

@Component({
  selector: 'ngx-img-picker',
  templateUrl: './img-picker.component.html',
  styleUrls: ['./img-picker.component.scss']
})
export class ImgPickerComponent implements OnInit {

  @Input() options: ImgCropperOptions = {
    aspectRatio: 1 / 1,
    maintainAspectRatio: false,
    cropperMinWidth: 0,
    cropperMinHeight: 0,
    cropperMaxWidth: 0,
    cropperMaxHeight: 0,
    resizeToWidth: 0,
    resizeToHeight: 0,
    viewMaxWidth: 0,
    viewMaxHeight: 0,
    viewMinWidth: 0,
    viewMinHeight: 0,
    selectedImage: null,
    maxSize: 0,
  }

  @Input() disabled: boolean = false;



  @ViewChild('uploader')
  inputField: ElementRef;

  imageChangedEvent: any = null;
  croppedImage: any = null;
  selectedImage: any = null;

  constructor(
    private locale: LocalizationService,
    private nbToast: NbToastrService,
    private ref: NbDialogRef<ImgPickerComponent>,
  ) { }

  ngOnInit(): void {
    //validate values to avoid null errors 
    !this.options.aspectRatio ? this.options.aspectRatio = 1 / 1 : null;
    !this.options.maintainAspectRatio ? this.options.maintainAspectRatio = false : null;
    !this.options.cropperMinWidth ? this.options.cropperMinWidth = 0 : null;
    !this.options.cropperMinHeight ? this.options.cropperMinHeight = 0 : null;
    !this.options.cropperMaxWidth ? this.options.cropperMaxWidth = 0 : null;
    !this.options.cropperMaxHeight ? this.options.cropperMaxHeight = 0 : null;
    !this.options.resizeToWidth ? this.options.resizeToWidth = 0 : null;
    !this.options.resizeToHeight ? this.options.resizeToHeight = 0 : null;
    !this.options.viewMaxWidth ? this.options.viewMaxWidth = 0 : null;
    !this.options.viewMaxHeight ? this.options.viewMaxHeight = 0 : null;
    !this.options.viewMinWidth ? this.options.viewMinWidth = 0 : null;
    !this.options.viewMinHeight ? this.options.viewMinHeight = 0 : null;
    this.options.selectedImage ? this.selectedImage = this.options.selectedImage : this.selectedImage = null;
    !this.options.maxSize ? this.options.maxSize = 0 : null;
  }

  fileChangeEvent(event: any): void {
    if (this.options.maxSize) {
      if (event.target.files[0].size > (this.options.maxSize * 1024)) {
        let title = "Image Size Exceeded";//this.locale.translate("components.img-cropper.maxSizeAllowedTitle");
        let message = "The image size exceeds the allowed size.";//this.locale.translate("components.img-cropper.maxSizeAllowed");
        UtilitiesService.showToastError(this.nbToast, title, message);
      } else {
        this.imageChangedEvent = event;
      }
    } else {
      this.imageChangedEvent = event;
    }

  }
  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;
  }
  cutImg() {
    this.selectedImage = this.croppedImage;
    this.imageChangedEvent = null;
    this.croppedImage = null;
    this.inputField.nativeElement.value = null;
  }

  acceptImg() {
    this.dismiss(this.selectedImage);
  }

  cancelImg() {
    this.imageChangedEvent = null;
    this.croppedImage = null;
    this.inputField.nativeElement.value = null;
  }

  clearImg() {
    this.inputField.nativeElement.value = null;
    this.imageChangedEvent = null;
    this.croppedImage = null;
    this.selectedImage = null;
  }

  loadImageFailed(event) {
    this.cancelImg();
  }

  dismiss(value: any) {
    this.ref.close(value);
  }

}
